import { Link } from 'react-router-dom'
import { getItemLink, getItemId, getItemName, getItemIcon } from './utils'
import HighlightText from './HighlightText'
import noFavorite from '../../assets/images/noFavorite.png'
import favorite from '../../assets/images/yesFavorite.png'
import { Lock } from 'lucide-react'

interface InteractiveSimpleCategoryCardProps {
  item: any
  showingType: 'subcategories' | 'cards'
  onCategoryClick?: (categoryId: number) => void
  onToggleFavorite?: (itemId: string) => void
  isFavorite?: boolean
  hasSubscription?: boolean
  searchQuery?: string
  onScrollToTop?: () => void
  lockContent?: boolean
}

const InteractiveSimpleCategoryCard = ({
  item,
  showingType,
  onCategoryClick,
  onToggleFavorite,
  isFavorite,
  hasSubscription,
  searchQuery = '',
  onScrollToTop,
  lockContent = false,
}: InteractiveSimpleCategoryCardProps) => {
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const target = e.target as HTMLImageElement
    target.style.display = 'none'
    target.nextElementSibling?.classList.remove('hidden')
  }

  const handleClick = (e: React.MouseEvent) => {
    if (showingType === 'subcategories' && onCategoryClick) {
      e.preventDefault()
      onScrollToTop?.()
      onCategoryClick(item.category_id)
    }
    // Для карточек (showingType === 'cards') позволяем стандартную навигацию по ссылке
  }

  const handleFavoriteClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    if (onToggleFavorite) {
      onToggleFavorite(getItemId(item, showingType).toString())
    }
  }

  const showFavoriteButton =
    hasSubscription && showingType === 'cards' && onToggleFavorite

  return (
    <Link
      key={getItemId(item, showingType)}
      to={getItemLink(item, showingType)}
      className="category-card"
      onClick={handleClick}
    >
      <img
        src={getItemIcon(item)}
        alt={getItemName(item, showingType)}
        onError={handleImageError}
        className="category-image"
      />
      {lockContent && <Lock className="lock-icon" size={32} />}
      <div className="category-info">
        <h3 className="category-name">
          <HighlightText
            text={getItemName(item, showingType)}
            searchQuery={searchQuery}
          />
        </h3>
      </div>
      {showFavoriteButton && (
        <button
          className={`favorite-button ${isFavorite ? 'favorite-active' : ''}`}
          onClick={handleFavoriteClick}
          title={isFavorite ? 'Удалить из избранного' : 'Добавить в избранное'}
        >
          {isFavorite ? (
            <img src={favorite} alt="favorite" className="favorite-icon" />
          ) : (
            <img src={noFavorite} alt="noFavorite" className="favorite-icon" />
          )}
        </button>
      )}
    </Link>
  )
}

export default InteractiveSimpleCategoryCard
